import React from 'react';

const Quote = () => { // eslint-disable-line
  return (
    <div id="quote">
      <p className="p-quote">
        Mathematics is not about numbers,
        equations, computations, or algorithms:
        it is about understanding. -William Paul Thurston
      </p>
    </div>
  );
};

export default Quote;
